import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ChangePassword from "./ChangePassword";
import ProfileEdit from "./ProfileEdit";
import UploadProfileImage from "./UploadProfileImage";
import { useNavigate } from "react-router-dom";

export default function ProfileSettings() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [formData, setFormData] = useState("");
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  useEffect(() => {
    if (profile) {
      setFormData(profile);
    }
  }, [profile]);

  const navigate = useNavigate();

  return (
    <div className="profile-setting">
      <div className="col-lg-10 p-0">
        <p className="breadcrumbs">
          <a onClick={() => navigate(`/${lan}/dashboard`)}>Dashboard &gt; </a>
          {profile?.role_type == 1 || profile?.role_type == 2 ? (
            ""
          ) : (
            <a onClick={() => navigate(`/${lan}/dashboard/manageprofile`)}>
              Manage profile &gt;
            </a>
          )}
          Profile settings
        </p>
        <div className="mb-4">
          <UploadProfileImage formData={formData} />
          {/* {formData?.country_title &&
            <p className="">Location: {formData?.country_title} </p>
          }
          {formData?.email_id &&
            <p className="">Email : {formData?.email_id} </p>
          } */}
        </div>
        <ProfileEdit formData={formData} />
        <ChangePassword formData={formData} />
      </div>
    </div>
  );
}
